import React from "react"
import SlickSlider from "react-slick"
import { ILink, ISlider } from "../../../gatsby-graphql"
import {
  Slide,
  SlideContent,
  SlideDescription,
  SliderWrapper,
  Row,
  PageNumber,
} from "./slider-elements"
import { Button, Heading, Link } from "../../ui"
import { ButtonType } from "../../ui/button/button-elements"
import ConditionalWrapper from "../../components/conditional-wrapper"

interface SliderProps {
  data?: ISlider
  arrows?: boolean
  fade?: boolean
  dots?: boolean
  pageNumbers?: boolean
  locale?: string
}

const Slider = ({ data, arrows, fade, dots, pageNumbers, locale }: SliderProps) => {
  if (!data) {
    return null
  }

  return (
    <SliderWrapper>
      <SlickSlider
        arrows={arrows ?? true}
        dots={dots ?? true}
        fade={fade ?? false}
        autoplay={data.autoplay ?? true}
        autoplaySpeed={(data.speed || 5) * 1000}
      >
        {data.slides?.map((slide, i) => (
          <div key={i}>
            <ConditionalWrapper
              condition={Boolean(
                slide?.link && (!slide.buttons || !slide.buttons.length)
              )}
              wrapper={children => (
                <Link link={slide?.link as ILink} locale={locale}>{children}</Link>
              )}
            >
              <Slide bgImg={slide?.background?.url as string}>
                <SlideContent>
                  <div>
                    {pageNumbers && (
                      <PageNumber>
                        {i + 1}/{data.slides?.length}
                      </PageNumber>
                    )}
                    <Heading.H2>{slide?.title}</Heading.H2>
                    {slide?.description && (
                      <SlideDescription>{slide?.description}</SlideDescription>
                    )}
                  </div>
                  <Row>
                    {slide?.buttons &&
                      slide?.buttons.length > 0 &&
                      slide?.buttons.map((button, index) => (
                        <Button
                          type={button?.type as ButtonType}
                          link={button?.link as ILink}
                          locale={locale}
                          key={index}
                        />
                      ))}
                  </Row>
                </SlideContent>
              </Slide>
            </ConditionalWrapper>
          </div>
        ))}
      </SlickSlider>
    </SliderWrapper>
  )
}

export default Slider
